var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"videoEl",class:{rotate: _vm.shouldRotate},attrs:{"autoPlay":"","muted":"","playsInline":""},domProps:{"muted":true}})}
var staticRenderFns = []

export { render, staticRenderFns }